<ng-container *ngIf="_userConfigTopbar && _userConfigTopbar.length>0">
    <div class="navigation">
        <img src="assets/icone_varie/breadcrumbs.svg">
        <span class="roboTitle">{{'users.topBarTitle' | translate}}</span>
        <button *ngFor="let conf of _userConfigTopbar" type="button" [routerLink]="'../'+conf.url"
            (click)='forceMainUser()' [ngClass]="conf.classStyle">{{conf.label | translate}}</button>
    </div>
    <hr>
</ng-container>
<app-navigator [navigator]="navigator"></app-navigator>
<hr *ngIf="!_userConfigTopbar || _userConfigTopbar.length==0">
<div class="row" [ngClass]="_userConfigTopbar && _userConfigTopbar.length>0 ? 'mt-2':''">
    <div class="form-group"
        [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
        <label class="roboSubTitle" for="admin">{{ 'placeholder.searchByUsername' | translate }}</label>
        <div class="input-group">
            <input #src type="text" class="form-control" [placeholder]="'placeholder.searchByUsername' | translate"
                aria-label="Cerca per nome" aria-describedby="basic-addon1" (keyup.enter)="searchByUsername(src.value)">
            <span class="input-group-text" id="basic-addon1" (click)="searchByUsername(src.value)"><i
                    class="bi bi-search" [ngbTooltip]="'tooltip.search' | translate"></i></span>
        </div>
    </div>
    <div class="form-group"
        [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
        <label class="roboSubTitle" for="environment">{{ 'placeholder.searchByVat' | translate }} </label>
        <div class="input-group">
            <input #srcIVA type="text" class="form-control" [placeholder]="'placeholder.searchByVat' | translate"
                aria-label="Cerca per nome" aria-describedby="basic-addon1" (keyup.enter)="searchByVat(srcIVA.value)">
            <span class="input-group-text" id="basic-addon1" (click)="searchByVat(srcIVA.value)"><i class="bi bi-search"
                    [ngbTooltip]="'tooltip.search' | translate"></i></span>
        </div>
    </div>
    <!--<div class="form-group"
        [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
        <label class="roboSubTitle" for="environment">{{ 'placeholder.searchByService' | translate }} </label>
        <div class="input-group">
            <app-select class="selectDm7" [options]="activeServices" [key]="'val'" [value]="'label'"
                [placeholder]="activeServices![0].label" [addNull]="false" [selectedKey]="activeServices![0].val"
                (change)="changeServices($event.key)">
            </app-select>
        </div>
    </div>-->
    <!-- visibilità utente-->
    <!--<div *ngIf="visibilityUsers" class="form-group"
        [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
        <label class="roboSubTitle" for="environment">{{ 'placeholder.searchByVisibility' | translate }} </label>
        <div class="input-group">
            <app-select class="selectDm7" [options]="visibilityUsers" [key]="'val'" [value]="'label'"
                [placeholder]="visibilityUsers![0].label" [addNull]="false" [selectedKey]="visibilityUsers![0].val"
                (change)="changeUserVisibility($event.key)">
            </app-select>
        </div>
    </div>-->
    <!-- fine visibilità ---->
</div>

<div [ngStyle]="{'justify-content': innerWidth! > 767 ? 'flex-end' : '100%'}"
    style="margin-bottom: 10px; margin-top:10px">
    <div class="row justify-content-between">
        <div class='col-auto' style="display: flex; flex-direction: row;">
            <label class="form-check-label" style='margin-right: 5px;'>{{'general.show' | translate}}</label>
            <div class="dm7Select">
                <div class="select-side">
                    <img src="assets/icone_varie/arrow_down.svg">
                </div>
                <app-select class="selectDm7" [options]="pages" [key]="'key'" [value]="'key'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="pages[1].key"
                    (change)="changePageSize($event.key)"></app-select>
            </div>
            <label class="form-check-label">{{'paginator.rows' | translate}}</label>
        </div>
        <div class="col d-flex justify-content-end">
            <div class="col-auto text-right">
                <app-paginator [ngStyle]="{'width': innerWidth! > 767 ? 'auto' : '60%'}" *ngIf="managedUsersTable"
                    [config]="managedUsersTable" (refresh)="getTable()" (next)="next()" (prev)="prev()"
                    (setPage)="setPage($event)"></app-paginator>
            </div>
            <!-- DISABILITATA LA CREAZIONE UTENTI  -->
            <div *ngIf="userInfo?.role == '3'" class="col-auto text-right">
                <button type="button" class="btn btn-primary btnAr4m" style="margin-top: 30px;" (click)="apriModalRegistrazione(registrazioneModal)"><i class="bi bi-plus"></i>Registra nuovo utente</button>
            </div>

            <ng-template #registrazioneModal let-modal>
                <div class="modal-header">
                    <h3 class="roboTitle title">Registrazione Utente</h3>
                    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
                </div>
                <div class="card-body" style="background-color: #EFEEE7;">
                    <div class="form-section">
                        <h4 style="font-weight: bold;">Dati Anagrafici</h4>
                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input type="text" class="form-control" id="email" [(ngModel)]="utente.email">
                        </div>
                        <div class="mb-3">
                            <label for="ragioneSociale" class="form-label">Nome e cognome o ragione sociale (se azienda)</label>
                            <input type="text" class="form-control" id="ragioneSociale" [(ngModel)]="utente.denominazione">
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label for="codiceFiscale" class="form-label">Codice Fiscale</label>
                                <input type="text" class="form-control" id="codiceFiscale" [(ngModel)]="utente.codice_fiscale">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="partitaIva" class="form-label">Partita IVA (controllo automatico con il VIES)</label>
                                <input type="text" class="form-control" id="partitaIva" (change)="controllaPiva($event)" [(ngModel)]="utente.partita_iva">
                            </div>
                        </div>
                    </div>
                        
                    <hr>

                    <div class="form-section">
                        <h4 style="font-weight: bold;">Sede della società</h4>
                        <div class="row">
                            <div class="col-md-8 mb-3">
                                <label for="indirizzo" class="form-label">Indirizzo *</label>
                                <input type="text" class="form-control" id="indirizzo" [(ngModel)]="utente.indirizzo">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="cap" class="form-label">CAP *</label>
                                <input type="text" class="form-control" id="cap" pattern="^[0-9]{5}$" [(ngModel)]="utente.cap">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label for="citta" class="form-label">Città *</label>
                                <input type="text" class="form-control" id="citta" [(ngModel)]="utente.comune">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="provincia" class="form-label">Provincia *</label>
                                <input type="text" class="form-control" id="provincia" pattern="^[A-Za-z]{2}$" [(ngModel)]="utente.provincia">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="nazione" class="form-label">Nazione *</label>
                                <input type="text" class="form-control" id="nazione" pattern="^[A-Za-z]{2}$" [(ngModel)]="utente.nazione">
                            </div>
                        </div>
                    </div>

                    <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="terminiCondizioni" [(ngModel)]="condizioni">
                        <label class="form-check-label" for="terminiCondizioni">Accetto i termini e le condizioni *</label>
                    </div>
                        
                    <div class="d-grid gap-2">
                        <button type="submit" class="btn btn-primary btnLogin" (click)="modal.dismiss()">Registra</button>
                        <button type="button" class="btn btn-secondary btn-lg" (click)="modal.dismiss()">Annulla</button>
                    </div>
                </div>
            </ng-template>

        </div>
    </div>

</div>


<ng-container *ngIf="(managedUsersTable && !loading); else waiting">
    <div *ngIf="managedUsersTable.data.length > 0; else noRes">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" (click)="sort('email')" style="cursor: pointer;">{{'users.table.username' |
                        translate}} <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('username')"
                            style="width: 20px;"></th>
                    <th scope="col">{{'users.table.den' | translate}}</th>
                    <th scope="col">{{'users.table.cf' | translate}}</th>
                    <th scope="col">{{'users.table.piva' | translate}}</th>
                    <!--<th width="10%" scope="col">{{'users.table.role' | translate}}</th>
                    <th width="5%" scope="col">{{'users.table.sfu' | translate}}</th>
            <th width="5%" scope="col">{{'users.table.sou' | translate}}</th>
                    <th width="7%" scope="col" style="text-align: center !important;">{{'users.table.invoices' | translate}}</th>
                    <th width="5%" scope="col" style="text-align: center !important;">{{'users.table.nso' | translate}}
                    </th>
                    <th width="5%" scope="col" style="text-align: center !important;">{{'users.table.ubl' | translate}}
                    </th>
                    <th width="5%" scope="col">{{'users.table.orders' | translate}}</th>
                    <th width="5%" scope="col" style="text-align: center !important;">{{'users.table.conf' | translate}}</th>
                    <th width="5%" scope="col">{{'users.table.rInvoices' | translate}}</th>
                    <th width="5%" scope="col">{{'users.table.rOrders' | translate}}</th>
                    <th width="5%" scope="col">{{'users.table.rDDT' | translate}}</th>-->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let u of managedUsersTable.data">
                    <td [routerLink]="[u.user_id]">
                        <i *ngIf="u.is_active == 'f'" class="bi bi-person-fill text-danger"></i>
                        {{u.email}}
                    </td>
                    <td [routerLink]="[u.user_id]">

                        {{u.denominazione}}

                    </td>
                    <td [routerLink]="[u.user_id]">
                        {{u.codice_fiscale}}
                    </td>
                    <td [routerLink]="[u.user_id]">
                        {{u.partita_iva}}
                    </td>
                    <!--<td [routerLink]="[u.user_id]">
                        {{u.rolename}}
                    </td>
                    <td>
                <img [src]="'assets/icone_varie/' + (u.abilita_peppol ? 'cerchio_check.svg' : 'error.svg')"
                style='width:30px;height:auto'>
            </td>
            <td>
                <img [src]="'assets/icone_varie/' + (u.abilita_nso ? 'cerchio_check.svg' : 'error.svg')"
                    style='width:30px;height:auto'>
            </td>
                    <td class='btnCol' style="text-align: center !important;">
                        <button type="button" class="btn btn-primary" (click)='setSessionUser(u)'> {{ 'sidebar.fatture' | translate }}</button>
                    </td>
                    <td style="text-align: center !important;">
                         ORDINI NSO 
                        <button type="button" class="btn btn-primary" [disabled]="!u.abilita_nso"
                            (click)='setSessionNSOUser(u)'> {{ 'sidebar.docsNSO' | translate }}</button>
                    </td>-->
                    <!--<td style="text-align: center !important;">
                         DOCUMENTI UBL
                        <button type="button" class="btn btn-primary"
                            [disabled]="(u.abilita_peppol==0) && (u.abilita_ddt==0)" (click)='setSessionPeppolUser(u)'>
                            {{ 'sidebar.docsUBL' | translate }}</button>
                    </td> -->
                    <!--<td class='btnCol' style="text-align: center !important;">
                        <button type="button" class="btn btn-primary" [routerLink]="['../configuration', u.dms_user_id]" (click) = 'setSessionUser(u)'> {{ 'users.table.conf' | translate }}</button> 
                        <button type="button" class="btn btn-primary" (click)='setSessionConfUser(u)'> {{
                            'users.table.conf' | translate }}</button>
                    </td>-->
                    <!--<td>
                        0
                    </td>
                    <td>
                        {{u.limite_ordini}}
                    </td>
                    <td>
                        {{u.limite_ddt}}
                    </td>-->
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template #noRes>
        <div>
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
        </div>
    </ng-template>
</ng-container>

<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>




<router-outlet></router-outlet>